import React from "react";
import DateHelpers from "../Helper/DateHelpers";
import AdminReservationCardList from "../Components/AdminReservationCardList";
import AdminGroupAccountCardList from "../Components/AdminGroupAccountCardList";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '../Styles/GroupAccountSearch.scss';

function GroupAccountSearch() {
   console.log("Group account search")
   const [queriedGroupAccounts, setQueriedGroupAccounts] = useState()
   const [searchSelection, setSearchSelection] = useState('')
   const [openEvents, setOpenEvents] = useState()
   const [archivedEvents, setArchivedEvents] = useState()
   const [selectedEvents, setSelectedEvents] = useState()

   const getGroupAccounts = async () => {
      try {

         // Get Transactions
         const defaultTransactions = await fetch('/getgroupaccounts', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               // groupAccountSearchCriteria,
               searchSelection
            })
         })
         var response = await defaultTransactions.json()
         console.log("here's group accounts", response)
         setQueriedGroupAccounts(response.data.groupAccounts)
      } catch (error) {

      }
   }

     useEffect(() => {
         getGroupAccounts()
      }, [])

   return (
      <div className="GroupAccountSearchBackground">
         <div className="GroupAccountSearchForeground">
            <div className="GroupAccountSearchHeading">
               <div
                  className="GroupAccountSearchInvisibleDiv">
               </div>
               <div className='GroupAccountSearchHeadingText'>
                  View and Manage Church Groups
               </div>
               <div className="GroupAccountSearchHeadingBackButton">

               </div>
            </div>

            <div className="GroupAccountSearchSelectOptions">
               <div className="GroupAccountSearchSearch">
                  <div className="GroupAccountSearchSearchText">
                     <input
                        id='transactionSearch'
                        type='text'
                        value={searchSelection}
                        placeholder="Group Name"
                        onChange={(event) => setSearchSelection(event.target.value)}
                     />
                  </div>
                  <div className="GroupAccountSearchSearchButton">
                     <button onClick={(event) => getGroupAccounts()}>
                        Search
                     </button>
                  </div>
               </div>
            </div>
            <div className="GroupAccountSearchContentCards">
               <AdminGroupAccountCardList
                  queriedAccounts={queriedGroupAccounts} />
            </div>
         </div>
      </div>

   )
}
export default GroupAccountSearch